<template>
  <div class="card-content">
    <div class="columns">
      <div class="column is-2">
        <b-field :label="$t('addAgence.infoComplementaire.prefixeCodeFacture')">
          <b-input v-model="agence.prefixeCodeFacture"></b-input>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field :label="$t('addAgence.infoComplementaire.suffixeCodeFacture')">
          <b-input v-model="agence.suffixeCodeFacture"></b-input>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field :label="$t('addAgence.infoComplementaire.codeMetier')">
          <b-input v-model="agence.codeMetier"></b-input>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field :label="$t('addAgence.infoComplementaire.codeSite')">
          <b-input v-model="agence.codeSite"></b-input>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field :label="$t('addAgence.infoComplementaire.domiciliationBancaire')"
        class="obligatoire">
          <b-select v-model="agence.domiciliationBancaireId" expanded>
            <option v-for="domiciliation in domiciliationsBancaire"
                    :value="domiciliation.id" :key="domiciliation.id">
              {{ `${domiciliation.libelle} - ${domiciliation.libelleBanque}` }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field :label="$t('addAgence.infoComplementaire.regimeTva')">
          <b-select v-model="agence.regimeTvaId" expanded>
            <option v-for="regimeTva in regimesTva"
                    :value="regimeTva.id" :key="regimeTva.id">
              {{ regimeTva.tauxTva | formatPercent }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    agence: {
      type: Object,
      required: true,
    },
    societeId: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametresWithoutFilterSocieteId',
    }),
    domiciliationsBancaire() {
      if (!this.societeId) return [];
      const domBancaires = this.parametre(PARAMETRES_KEYS.domiciliationBancaire)
        .filter((domBancaire) => {
          return domBancaire.societeId === this.societeId && domBancaire.actif;
        });
      return domBancaires;
    },
    regimesTva() {
      if (!this.societeId) return [];
      const regimesTva = this.parametre(PARAMETRES_KEYS.regimeTva)
        .filter((regimeTva) => {
          return regimeTva.societeId === this.societeId && regimeTva.actif;
        });
      return regimesTva;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
  },
  mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.loadParametres([PARAMETRES_KEYS.domiciliationBancaire, PARAMETRES_KEYS.regimeTva]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
